var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import styled, { css, useTheme } from "styled-components";
import { Box } from "../../Box";
const StyledRow = styled(Box).attrs({
    as: "tr",
}) `
  &:hover {
    background-color: ${({ theme: { colors: { tableColors }, }, }) => tableColors.tableRowHover};
  }
  ${({ isClickable }) => isClickable &&
    css `
      cursor: pointer;
    `}
  ${({ isSelected }) => isSelected &&
    css `
      background-color: ${({ theme: { colors: { tableColors }, }, }) => tableColors.tableRowHover};
    `}
`;
const getWordBreakSxProps = (column) => column.nowrap ? {} : { wordBreak: "break-word", wordWrap: "break-word" };
export const TableRow = (_a) => {
    var { "data-testid": dataTestId = "row", idx, onClick, row, getCellProps = () => undefined } = _a, props = __rest(_a, ["data-testid", "idx", "onClick", "row", "getCellProps"]);
    const { colors: { tableColors }, } = useTheme();
    const bgColor = idx % 2 ? tableColors.tableRowEven : tableColors.tableRowOdd;
    // keys are contained in spread props, but not known by linter
    /* eslint-disable react/jsx-key */
    return (React.createElement(StyledRow, { bg: bgColor, "data-testid": dataTestId, isClickable: !!onClick, isSelected: row.isSelected, onClick: onClick && ((event) => onClick(row.original, event)), verticalAlign: "top" }, row.cells.map((cell) => (React.createElement(Box, Object.assign({ as: "td", p: 2, sx: Object.assign(Object.assign({}, getWordBreakSxProps(cell.column)), { 
            // support legacy padding
            "&:first-child": {
                p: "8px 8px 8px 18px",
            }, "&:last-child": {
                p: "8px 18px 8px 8px",
            } }), "data-testid": cell.column.testId, width: cell.column.width || "initial", minWidth: cell.column.minWidth || "initial", maxWidth: cell.column.maxWidth || "initial" }, cell.getCellProps(getCellProps(cell)), props), cell.render("Cell"))))));
    /* eslint-enable react/jsx-key */
};
